import flow from 'lodash/flow'

import { replaceFalsyWithFalse } from '../../utils/replace-falsy-with-false'

import { getMappedProduct } from './get-mapped-product'

export const mapProduct = (product) =>
  flow(getMappedProduct, replaceFalsyWithFalse)(product)
